<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 系统管理</el-breadcrumb-item>
                <el-breadcrumb-item>订单事件</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form v-show='showSearch' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select filterable clearable size='mini' v-model='queryParams.provider'
                                           placeholder='支付方式'>
                                    <el-option
                                        v-for='item in paymentProviderOptions'
                                        :key='item.value'
                                        :label='item.label'
                                        :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0' label='处理状态'>
                                <el-switch
                                    v-model='queryParams.status'
                                    active-color='#13ce66'
                                    inactive-color='#ff4949'>
                                </el-switch>
                            </el-form-item>
                            
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='tableList'
                      @sort-change='handleSortChange'>
                <el-table-column align='center' width='250' label='事件Id' prop='id' />
                <el-table-column align='center' width='150' label='订单号' prop='orderId' />
                <el-table-column align='center' width='200' label='类型' prop='eventType' />
                <el-table-column align='center' label='支付方式' width='100' prop='provider'>
                    <template slot-scope='scope'>
                        <span>{{ paymentProviderOptions.find(t => t.value === scope.row.provider) ? paymentProviderOptions.find(t => t.value === scope.row.provider).label : '未知'
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='事件处理状态'>
                    <template slot-scope='scope'>
                        <el-tag size='mini' :type='scope.row.status ? "success" : "warning"'>
                            {{ scope.row.status ? '已处理' : '处理失败' }}
                        </el-tag>
                    </template>
                </el-table-column>
                
                <el-table-column align='center' label='重试次数'>
                    <template slot-scope='scope'>
                        <span>{{ scope.row.retryCount }}</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' label='事件详情'>
                    <template slot-scope='scope'>
                        <el-button @click='viewShippingDetail(scope.row)' type='text'>
                            查看
                        </el-button>
                        <el-button @click='copyContent(scope.row.data)' type='text'>
                            复制
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column align='center' sortable='custom' width='150' label='创建时间' prop='createTime' />
                <el-table-column align='center' sortable='custom' width='150' label='最后修改时间' prop='updateTime' />
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-sizes='[15, 30, 45, 60, 75, 100, 200, 300]'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='sizes, prev, pager, next'
                    @size-change='handleSizeChange'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <el-dialog title='发货详情' :visible.sync='openShippingDetail' width='40%' append-to-body>
                <vue-json-pretty :data='currentShippingDetail' />
            </el-dialog>
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import { deepCopy } from '@/utils/object';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';
import CottonFileUpload from '@/components/component/CottonFileUpload.vue';
import DynamicForm from '@/components/component/DynamicForm.vue';
import { projectServiceStatusApi } from '@api/project/projectServiceStatusApi';
import { exportPayOrderApi } from '@api/pay/payOrderApi';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import { exportPayEventApi } from '@api/pay/payEventApi';
import { copyContent } from '@/utils/string/cottonPlugin';

export default {
    name: 'AppMd5',
    components: { DynamicForm, CottonFileUpload, VueJsonPretty },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            batchDeleteStatus: false,
            // 显示搜索条件
            showSearch: true,
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                provider: undefined,
                status: undefined
            },
            updateStatus: false,
            projectInfoMap: new Map,
            projectInfoList: [],
            
            tableList: [],
            currentTableData: {},
            serviceStatusOptions: [
                {
                    label: '未开服',
                    value: 'PRE_LAUNCH'
                },
                {
                    label: '已上线',
                    value: 'ONLINE'
                },
                {
                    label: '维护中',
                    value: 'MAINTENANCE'
                },
                {
                    label: '即将维护/关闭',
                    value: 'SHUTTING_DOWN'
                }
            ],
            paymentProviderOptions: [
                {
                    label: '微信',
                    value: 'WEIXIN_PAY'
                },
                {
                    label: '支付宝',
                    value: 'ALIPAY'
                },
                {
                    label: '谷歌',
                    value: 'GOOGLE'
                },
                {
                    label: 'AppStore',
                    value: 'APPLE'
                },
                {
                    label: '华为支付',
                    value: 'HUAWEI'
                },
                {
                    label: '鸿蒙支付',
                    value: 'HARMONY_OS'
                },
                {
                    label: 'TapTap',
                    value: 'TAPTAP'
                },
                {
                    label: '好游快爆',
                    value: 'OPEN3839'
                }
            ],
            orderStatusOptions: [
                {
                    label: '订单已创建',
                    value: 'BILL_CREATED',
                    type: ''
                },
                {
                    label: '等待支付',
                    value: 'WAITING',
                    type: ''
                },
                {
                    label: '支付成功',
                    value: 'SUCCESS',
                    type: 'success'
                },
                {
                    label: '支付失败',
                    value: 'FAILED',
                    type: 'danger'
                },
                {
                    label: '发生退款',
                    value: 'REFUND',
                    type: 'danger'
                },
                {
                    label: '订单关闭',
                    value: 'CLOSED',
                    type: ''
                }
            ],
            shippingStatusOptions: [
                {
                    label: '已发货',
                    value: true
                },
                {
                    label: '未发货',
                    value: false
                }
            ],
            timePicker: {
                pickerTimeValue: [],
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近一个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近三个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近五个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ]
                }
            },
            
            openShippingDetail: false,
            currentShippingDetail: {}
        };
    },
    computed: {
        computeStatusLabel() {
            return (status, t) => {
                const option = this.serviceStatusOptions.find(
                    item => item.value === status
                );
                return option ? option.label : '未知状态';
            };
        }
    },
    created() {
        this.getList();
        
        // 查询项目信息
        queryProjectInfoList({ pageSize: 100000 }).then(result => {
            if (result.code === 200) {
                if (result.data && result.data.result) {
                    result.data.result.forEach(v => {
                        this.projectInfoList.push(v);
                        this.projectInfoMap.set(v.appId, v.cnName);
                    });
                }
            }
        });
    },
    methods: {
        copyContent,
        /** 查询字典类型列表 */
        getList() {
            this.loading = true;
            if (!this.queryParams.status) {
                this.queryParams.status = undefined;
            }
            if (!this.queryParams.provider) {
                this.queryParams.provider = undefined;
            }
            exportPayEventApi.queryList(this.queryParams).then(response => {
                if (response.code === 200) {
                    this.tableList = response.data.result;
                    this.queryParams.total = response.data.total;
                    
                    this.queryParams.pageNum = response.data.pageNum;
                }
                this.loading = false;
            });
        },
        /** 提交按钮 */
        async submitForm() {
            if (!this.currentTableData.status || !this.currentTableData.projectAppId) {
                message.error('项目名未选择或服务器状态未选择!');
                return;
            }
            
            if (this.currentTableData.customData) {
                try {
                    JSON.parse(this.currentTableData.customData);
                } catch (e) {
                    message.error('自定义的数据不是JSON');
                    return;
                }
            }
            
            if (this.updateStatus) {
                projectServiceStatusApi.update(this.currentTableData).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        this.getList();
                        this.open = false;
                    }
                });
            } else {
                projectServiceStatusApi.insert(this.currentTableData).then(result => {
                    if (result.code === 200) {
                        // 添加游戏的下载渠道
                        message.success('添加成功');
                        this.getList();
                        this.open = false;
                    }
                });
            }
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除"' + row.id + '"的数据项？').then(function() {
                return projectServiceStatusApi.deleteData(row);
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        async handleSortChange({ column, prop, order }) {
            let sortType = null;
            if (order === 'ascending') {
                sortType = 'ASC';
            } else if (order === 'descending') {
                sortType = 'DESC';
            }
            
            let newSortSql = prop + ' ' + sortType;
            if (this.queryParams.sortSqlList.length > 0) {
                let sortAddStatus = false;
                for (let i = 0; i < this.queryParams.sortSqlList.length; i++) {
                    let sortSql = this.queryParams.sortSqlList[i];
                    if (sortSql.indexOf(prop) !== -1) {
                        // 存在排序sql
                        this.queryParams.sortSqlList.splice(i, 1);
                        if (order) {
                            this.queryParams.sortSqlList.push(newSortSql);
                        }
                        sortAddStatus = true;
                    }
                    if (i === this.queryParams.sortSqlList.length - 1) {
                        if (!sortAddStatus) {
                            this.queryParams.sortSqlList.push(newSortSql);
                        }
                    }
                }
            } else {
                this.queryParams.sortSqlList.push(newSortSql);
            }
            this.getList();
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
        },
        // 表单重置
        reset() {
        
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                projectAppId: undefined,
                sortSqlList: [
                    'createTime desc'
                ],
                provider: undefined,
                status: undefined
            };
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '新增项目服务器状态';
            this.updateStatus = false;
            this.currentTableData = {};
        },
        handleBatchDelete() {
            let idList = this.ids;
            const obj = this;
            
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.batchDeleteStatus = this.ids.length > 0;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.open = true;
            this.title = '修改项目服务器状态';
            this.updateStatus = true;
            this.currentTableData = deepCopy(row);
            this.open = true;
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleTimePickerBlur() {
            if (this.timePicker.pickerTimeValue.length === 0) {
                return;
            }
            this.queryParams.startTime = this.timePicker.pickerTimeValue[0] + ' 00:00:00';
            this.queryParams.endTime = this.timePicker.pickerTimeValue[1] + ' 23:59:59';
            this.refresh();
        },
        reshipping(data) {
            let msg = `是否对订单 ${data.id}进行重新发货?`;
            if (data.shippingStatus) {
                msg = `${msg} 该操作会导致系统发货次数大于1`;
            }
            this.$modal.confirm(msg).then(function() {
                let value = { id: data.id, shippingStatus: false, shippingRetryCount: 1 };
                return exportPayOrderApi.update(value);
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('重新发货申请提交成功');
                }
            }).catch(() => {
            });
        },
        reshippingConfirm(data) {
            this.$modal.confirm(`是否对订单 ${data.id} 进行重新核销, 该操作会向${data.provider}发送订单核销通知`).then(function() {
                let value = { id: data.id, shippingConfirmStatus: false, shippingConfirmRetryCount: 1 };
                return exportPayOrderApi.update(value);
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('订单核销通知提交成功');
                }
            }).catch(() => {
            });
        },
        viewShippingDetail(data) {
            if (!data.data) {
                message.error('无事件数据');
                return;
            }
            this.currentShippingDetail = JSON.parse(data.data);
            this.openShippingDetail = true;
        }
    }
};
</script>
<style>

</style>
